// export const BASE_URL = "https://language-app-dtnzdnd5dq-no.a.run.app";
export const BASE_URL = "http://localhost:8080";
